/**
 * Recognized event type
 * @type {{RENDER: string, PAYMENT: string}}
 */
export const EventType = {
    RENDER: 'RENDER'
    , PAYMENT: 'PAYMENT'
}